// extracted by mini-css-extract-plugin
export var dropdownIcon = "_iq-6";
export var imgContainer = "_iq-3";
export var menuIcon = "_iq-5";
export var pillWrapper = "_iq-2";
export var pillsContainer = "_iq-1";
export var subscriptionCard = "_iq-0";
export var subscriptionLogo = "_iq-4";